import { updateBundleTotal } from 'helpers/bundle-total'

export const addBundleLineItem = (variant, imageUrl, title, bundleIndex, price, comparePrice) => {
  const lineItemsContainer = document.querySelector('.product-bundles__line-items')
  if (!lineItemsContainer) return

  const uniqueId = `${variant.id}-bundle-${bundleIndex}`
  const existingItem = lineItemsContainer.querySelector(`[data-unique-id="${uniqueId}"]`)
  if (existingItem) return

  const newItem = document.createElement('li')
  newItem.className = 'product-bundles__line-item'
  newItem.setAttribute('data-variant-id', variant.id)
  newItem.setAttribute('data-bundle-index', bundleIndex)
  newItem.setAttribute('data-unique-id', uniqueId)
  // Fixed at 1 now the stepper is gone. Kept as an attribute because the item count, the bundle
  // total and the add-to-cart payload all read it -- a shopper wanting two of something adds the
  // second from the carousel as its own line.
  newItem.setAttribute('data-quantity', '1')
  newItem.setAttribute('data-fallback-price', price || 0)
  newItem.setAttribute('data-fallback-compare-price', comparePrice || price || 0)

  newItem.innerHTML = `
    <img src="${imageUrl}" alt="${title}">
    <button class="product-bundles__line-item-remove" data-remove-item data-variant-id="${variant.id}">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"/><path fill="#363636" stroke="#363636" stroke-linecap="round" stroke-linejoin="round" d="m9.594 14.406 4.812-4.812"/><path fill="#363636" stroke="#363636" stroke-linecap="round" stroke-linejoin="round" d="m9.594 9.594 4.812 4.812"/></svg>
    </button>
  `

  const removeBtn = newItem.querySelector('[data-remove-item]')
  removeBtn.addEventListener('click', () => {
    // Scoped to the card: the PDP wishlist button shares data-variant-id with the main product.
    const checkbox = document.querySelector(`.product-bundles [data-accordion-bundle="${bundleIndex}"] .plp-card-checkbox[data-variant-id="${variant.id}"]`)
    if (checkbox) {
      checkbox.classList.remove('checked')
    }
    removeBundleLineItem(variant.id, bundleIndex)
  })

  lineItemsContainer.appendChild(newItem)
  updateBundleSummary()
  updateBundleTotal()
}

export const removeBundleLineItem = (variantId, bundleIndex) => {
  const lineItemsContainer = document.querySelector('.product-bundles__line-items')
  if (!lineItemsContainer) return
  const uniqueId = `${variantId}-bundle-${bundleIndex}`
  const itemToRemove = lineItemsContainer.querySelector(`[data-unique-id="${uniqueId}"]`)
  if (itemToRemove) {
    itemToRemove.remove()
    updateBundleSummary()
    updateBundleTotal()
  }
}

export const updateBundleSummary = () => {
  const lineItems = document.querySelectorAll('.product-bundles__line-items .product-bundles__line-item')
  let totalItemCount = 0

  lineItems.forEach(item => {
    const quantity = parseInt(item.getAttribute('data-quantity') || 1)
    totalItemCount += quantity
  })

  const itemCountElement = document.querySelector('[data-item-count]')
  if (itemCountElement) {
    itemCountElement.textContent = totalItemCount
  }

  const selectedNamesElement = document.querySelector('.js-bundle-selected-names')
  if (selectedNamesElement) {
    selectedNamesElement.textContent = ''
    lineItems.forEach(item => {
      const name = item.querySelector('img')?.getAttribute('alt')
      if (!name) return
      const nameItem = document.createElement('li')
      nameItem.className = 'product-bundles__selected-name'
      nameItem.textContent = name
      selectedNamesElement.appendChild(nameItem)
    })
  }

  if (window.updateBundleAccordionStates) {
    window.updateBundleAccordionStates()
  }

  if (window.updateBundleAddToCartButtonState) {
    window.updateBundleAddToCartButtonState()
  }

  if (window.updateBundleSelectedBadges) {
    window.updateBundleSelectedBadges()
  }
}
